import { Center, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { userManager } from '@/auth/oidcClient';
import { LoadingState } from '@/components/LoadingState';
import { ErrorState } from '@/components/ErrorState';

export function CallbackPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await userManager.signinCallback();
        if (!cancelled) navigate('/', { replace: true });
      } catch (e) {
        if (!cancelled) setError(e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <Center mih="100vh">
        <Stack maw={500}>
          <ErrorState error={error} />
        </Stack>
      </Center>
    );
  }

  return (
    <Center mih="100vh">
      <Stack align="center">
        <LoadingState label={t('state.loading')} />
        <Text c="dimmed">{t('app.title')}</Text>
      </Stack>
    </Center>
  );
}

export function SilentCallbackPage() {
  useEffect(() => {
    void userManager.signinSilentCallback().catch(() => undefined);
  }, []);
  return null;
}
